import {
  combineTranslationBundles,
  type TranslationModule
} from '@hconnect/common/localization-loaders'
import {commonFiltersWidgetTranslations} from '@widgets/common-filters'

import {SHIFT_EVENT_FILTERS_WIDGET_NAMESPACE} from '../consts'

const shiftEventFiltersTranslationModule: TranslationModule = {
  namespace: SHIFT_EVENT_FILTERS_WIDGET_NAMESPACE,
  resources: {
    'en-US': () => import('./en_US.json'),
    'en-GB': () => import('./en_GB.json'),
    'de-DE': () => import('./de_DE.json'),
    'ru-RU': () => import('./ru_RU.json'),
    'it-IT': () => import('./it_IT.json'),
    'fr-FR': () => import('./fr_FR.json'),
    'cs-CZ': () => import('./cs_CZ.json'),
    'hu-HU': () => import('./hu_HU.json'),
    'nl-NL': () => import('./nl_NL.json'),
    'sv-SE': () => import('./sv_SE.json'),
    'es-ES': () => import('./es_ES.json'),
    'ro-RO': () => import('./ro_RO.json'),
    'no-NO': () => import('./no_NO.json'),
    'pl-PL': () => import('./pl_PL.json'),
    'bs-BA': () => import('./bs_BA.json'),
    'da-DK': () => import('./da_DK.json'),
    'kk-KZ': () => import('./kk_KZ.json'),
    'pt-PT': () => import('./pt_PT.json'),
    'th-TH': () => import('./th_TH.json')
  }
}

const externalPackageTranslations: TranslationModule[] = combineTranslationBundles([
  commonFiltersWidgetTranslations
])

export const shiftEventFiltersWidgetTranslations = combineTranslationBundles([
  externalPackageTranslations,
  shiftEventFiltersTranslationModule
])
